import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customOptions"]
  static values = {
    customScope: String
  }

  connect() {
    console.log("connect");
    this.toggle()
  }

  toggle() {
    const selectedScope = this.element.querySelector('input[name="icalendar_configuration[scope]"]:checked')?.value
    console.log("pouet");
    console.log(selectedScope);

    if (selectedScope === this.customScopeValue) {
      this.customOptionsTarget.classList.remove("hidden")
    } else {
      this.customOptionsTarget.classList.add("hidden")
    }
  }
}